// Detalle currently bundles read/write settlement access; there is no separate
// persisted write flag. The inbox inherits this permission, never its own grant.
export function canAccessSettlementInbox(profile: {
  roles: string[];
  exporter_id?: number | null;
  permissions?: Array<{ sidebarItemKey: string; enabled: boolean }>;
} | null | undefined): boolean {
  if (!profile?.exporter_id) return false;
  return profile.roles.some(role => role === 'admin' || role === 'superadmin') ||
    (profile.roles.includes('basic') && Boolean(profile.permissions?.some(
      permission => permission.sidebarItemKey === 'Detalle' && permission.enabled
    )));
}

// Registrar precios sin contenedor guarda en la Bitácora: el servidor
// (save_market_price_capture) exige ese permiso a los usuarios basic.
export function canLogPricesWithoutContainer(profile: {
  roles: string[];
  permissions?: Array<{ sidebarItemKey: string; enabled: boolean }>;
} | null | undefined): boolean {
  if (!profile) return false;
  return profile.roles.some(role => role === 'admin' || role === 'superadmin') ||
    (profile.roles.includes('basic') && Boolean(profile.permissions?.some(
      permission => permission.sidebarItemKey === 'logbook' && permission.enabled
    )));
}
